import React, { useEffect } from 'react'
import { Input, Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { Col } from 'styled-bootstrap-grid'
import _ from 'lodash'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNavigationWrapper, WizardNav, NavProps } from '../../../components/Wizard/WizardNav'
import { CenteredRow, Label } from '../../../components/Page/Layout'
import { Row } from '../../../components/Grid'
import { getHookValidationResult, isValidating, selectedHook } from '../../../features/hook/selectors'
import { HookActions } from '../../../features/hook/actions'
import { getPaymentTemplates } from '../../../features/paymentTemplate/selectors'
import { PaymentTemplate } from '../../../features/paymentTemplate/types'
import { PaymentTemplateActions } from '../../../features/paymentTemplate/actions'

const { Option } = Select

const StyledSelect = styled(Select)`
  width: 100%;
`

const ModalHook = styled.div`
  border: 1px solid #eee;
  border-radius: 0.8rem !important;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px;

  .hook.title {
    text-align: center;
  }

  .hook-image {
    height: 120px;
    width: auto;
  }

  .hook-button {
    background-color: #629d33;
    border-color: #5c9330;
    width: 75% !important;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
    text-align: center;
    vertical-align: middle;
    color: white !important;
    min-height: 38px;
  }
  .hook-button:hover {
    cursor: pointer;
    text-decoration: none;
  }
`

const UrlImageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  > div:first-child {
    width: calc(100% - 130px);
  }
  > div:last-child {
    display: flex;
    align-items: flex-end;
  }
`

const ButtonIcon = styled.div`
  img {
    width: 40px;
    height: auto;
  }
  cursor: pointer;
`

type Props = {
  close?: () => void
  addHook: () => void
} & NavProps

export const AddHookElements = ({ addHook, ...rest }: Props) => {
  const dispatch = useDispatch()
  const hook = useSelector(selectedHook)
  const status = useSelector(getHookValidationResult)
  const paymentTemplates = useSelector(getPaymentTemplates)
  const loading = useSelector(isValidating)

  useEffect(() => {
    dispatch(PaymentTemplateActions.fetchPaymentTemplates())
  }, [dispatch])

  const changeHandler = async (field: string, e: React.ChangeEvent<HTMLInputElement>) => {
    if (hook && hook.name) {
      const hookToValidate = { ...hook, [field]: e.target.value }
      dispatch(HookActions.updateNewHook(hookToValidate))
    }
  }
  const changePaymentTemplateHandler = async (field: string, e: string) => {
    if (hook && hook.name) {
      const hookToValidate = { ...hook, [field]: e }
      dispatch(HookActions.updateNewHook(hookToValidate))
    }
  }

  const changeImageUrl = (url: string) => {
    if (hook && hook.name) {
      const hookToValidate = { ...hook, image: `https://test2019.yooppe.com/images/popup_images/${url}.png` }
      dispatch(HookActions.updateNewHook(hookToValidate))
    }
  }

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <Row>
          <Col md={8}>
            <CenteredRow>
              Configura <strong>&nbsp;&nbsp;{hook?.name}</strong>
            </CenteredRow>
            <Row marginV={40}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <UrlImageWrapper>
                  <div>
                    <Label>Url Immagine</Label>
                    <Input
                      placeholder="Es. http://..."
                      value={hook?.image}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('image', e)}
                    />
                  </div>
                  <div>
                    <ButtonIcon onClick={() => changeImageUrl('photo_public')}>
                      <img src="https://test2019.yooppe.com/images/popup_images/photo_public.png" alt="public" />
                    </ButtonIcon>
                    <ButtonIcon onClick={() => changeImageUrl('favorite')}>
                      <img src="https://test2019.yooppe.com/images/popup_images/favorite.png" alt="favorite" />
                    </ButtonIcon>
                    <ButtonIcon onClick={() => changeImageUrl('chat')}>
                      <img src="https://test2019.yooppe.com/images/popup_images/chat.png" alt="chat" />
                    </ButtonIcon>
                  </div>
                </UrlImageWrapper>
              </Col>
            </Row>
            <Row marginV={40}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>Titolo Hook</Label>
                <Input
                  value={hook?.title}
                  placeholder="Es. Vuoi vedere i profili ?"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('title', e)}
                />
              </Col>
            </Row>
            <Row marginV={40}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>Testo Bottone</Label>
                <Input
                  value={hook?.button}
                  placeholder="Es. Continua"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeHandler('button', e)}
                />
              </Col>
            </Row>
            <Row marginV={40}>
              <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
                <Label>Template di pagamento</Label>
                <StyledSelect onSelect={(e: any) => changePaymentTemplateHandler('paymentTemplateId', e)}>
                  {paymentTemplates &&
                    _.map(paymentTemplates, (template: PaymentTemplate) => {
                      return (
                        <Option value={template.id} key={template.id}>
                          {template.name}
                        </Option>
                      )
                    })}
                </StyledSelect>
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <ModalHook>
              <div className="hook-image">
                <img src={hook?.image} alt="hook icon" />
              </div>
              <div className="hook-title">{hook?.title}</div>
              <div className="hook-button">{hook?.button}</div>
            </ModalHook>
          </Col>
        </Row>

        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid || loading} nextStep={addHook} nextStepText="Salva" />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
